import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import axios from "axios"
import { useEffect, useState } from "react"
import * as Constants from './Constants'
import { useNavigate } from "react-router-dom"

const Header = () => {
  const [categories, setCategories] = useState([]);
  const [searchInput, setSearchInput] = useState('none');
  const [searchWord, setSearchWord] = useState('');
  const [searchFilteringData, setSearchFilteringData] = useState([]);
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);


  useEffect(() => {
    
    axios.get(`${Constants.LARAVEL_API_URL}/categories`).then(res => {
        if (res.data.status === 200) {
          setCategories(res.data.categories);
        }
      }).catch();

  }, []);

  //Search
  const searchHandler = async (event) => {
    const searchWord = event.target.value;
    setSearchWord(searchWord);
    if (searchWord.length > 3) {
        const { data } = await axios.get(`${Constants.LARAVEL_API_URL}/searchresult/${searchWord}`);       
        if(data.products){
            setSearchFilteringData(data.products.slice(0,30));
            setSearchInput('block');
        }
    } else {
        setSearchFilteringData([]);
        setSearchInput('none');
    }
}

const menuHandler = () => {
  setOpenMenu(!openMenu);
}

let searchList = '';
searchList = searchFilteringData.slice(0, 10).map((item, idx) => {
    return (
        <div key={idx}>
            { item.searchCategory === null ? ' ' :
                <Link to={`/product/${item.slug}`} className="headerSearchItem">
                    <img className="homeMenuImg" src={`${Constants.LARAVEL_URL}/assets/images/products/${item.images}`} height={30} width={30} alt={item.name} />
                    <p>{item.name}</p>
                </Link>
            }
        </div>
    )
});// end search
const handleSearchBtn = () => {
  navigate(`/searchresult/${searchWord}`);
}


  return (
    <header>        
        <div className="headerHeadTopWrap">
          <div className="container">
            <div className="headerHeadTop">
              <nav>
                <ul>
                  <li>
                    <NavLink
                    to="/license"
                    >Лицензии и сертификаты</NavLink>
                  </li>
                  <li>
                    <NavLink 
                    to="/about"
                    >О нас</NavLink>
                  </li>
                  <li>
                    <NavLink 
                    to="/contacts"
                    >Контакты</NavLink>
                  </li>
                </ul>
              </nav>
              <div className="headerHeadTopRight">
                  <div className="headerHeadLink">
                      <i className="fas fa-phone-volume" aria-hidden="true"></i>
                      <a href="tel:+77717595949">+7 (771) 759-59-49</a>
                  </div>
                  <div className="headerHeadLink">
                    <i className="fas fa-envelope" aria-hidden="true"></i>
                      <a href="mailto:info@optech.kz">info@optech.kz</a>
                  </div>
                  <div className="headerLang">
                      RU
                  </div>
              </div>
            </div>
          </div>          
        </div>
        <div className="headerHeadWrap">
            <div className="container">
              <div className="headerHead">
                <div className="headerLogo">
                  <NavLink to="/" >
                    <img
                      src="/uploads/images/headerLogo.png"
                      width={266}
                      height={52}
                      className='headerLogoMobile'
                      alt="Оптические технологии"
                    />
                  </NavLink>
                  <p>Оптические технологии</p>
                </div>
                <div className="headerHeadNav">
                  <nav>
                    <ul>
                      <li>
                        <NavLink to="/" className=""><i className="fa-solid fa-house-chimney"></i></NavLink>
                      </li>
                      <li>
                        <NavLink to="/brands" className="">Бренды</NavLink>
                      </li>
                      <li>
                        <NavLink to="/projects" className="">Проекты</NavLink>
                      </li>
                      <li>
                        <NavLink to="/articles" className="">Новости</NavLink>
                      </li>
                      <li>
                        <NavLink to="/solutions" className="">Решения</NavLink>
                      </li>
                      <li>
                        <NavLink to="/services" className="">Сервис и услуги</NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div 
                  className="headerHeadBtn"
                  data-fancybox="group2"
                  data-src="#dialog-content"
                >оставить <br />заявку</div>
              </div>
            </div>
        </div>
        <div className="headerNavSearchWrap">
          <div className="container">
            <div className="headerNavSearch">
              <div className="headerCatalogNav" id="catalogBtn">
                <div className="headerCatalogBtn" onClick={menuHandler}>
                    <div className={`header__burger ${openMenu ? 'active' : ''}`}>
                        <span></span>
                    </div>                            
                    <h4>Каталог товаров</h4>
                </div>
                <div className={`header__menu ${openMenu ? 'active' : ''}`}>
                  <ul> 
                    {categories.map(category => (                    
                      <li key={category.id}>
                        <NavLink to={`/catalog/${category.slug}`} onClick={menuHandler}>
                          <img src={`${Constants.LARAVEL_URL}/assets/images/categories/${category.image}`} alt={category.name} width={50}  />
                          <p>{category.name}</p>
                        </NavLink>
                        <ul>
                          {category.children && category.children.map(child => (
                            <li key={child.id}>
                              <NavLink to={`/catalog/${category.slug}/${child.slug}`} onClick={menuHandler}>
                                {child.name}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>                
              </div>
              <div className="headerSearch">
                <form>
                  <input 
                    type="text" 
                    required
                    placeholder="Поиск по каталогу..." 
                    onChange={searchHandler}
                    onBlur={() =>
                        setTimeout(() => {
                            setSearchInput('none');
                        }, 100)
                    }
                  
                  />
                  <button type="submit" onClick={searchWord === '' ? null : handleSearchBtn}><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg></button>
                  <div className="headerSearchResult" style={{display: searchInput}} >
                      {searchList}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className={`${openMenu ? 'modalOverlayMy' : ''}`} onClick={menuHandler}></div>
        <div className='headerMobile'>
          <div className='headerMobileCatalog'>
              <div className="headerCatalogBtnMobile" >
                  <div className={`header__burger ${openMenu ? 'active' : ''}`} onClick={menuHandler}>
                      <span></span>
                  </div>
                  <div className={`header__menu__mobile ${openMenu ? 'active' : ''}`}>
                    <ul> 
                      {categories.map(category => (                    
                        <li key={category.id}>
                          <NavLink to={`/catalog/${category.slug}`} onClick={menuHandler}>
                            <img src={`${Constants.LARAVEL_URL}/assets/images/categories/${category.image}`} alt={category.name} width={50}  />
                            <p>{category.name}</p>
                          </NavLink>
                          <ul>
                            {category.children && category.children.map(child => (
                              <li key={child.id}>
                                <NavLink to={`/catalog/${category.slug}/${child.slug}`} onClick={menuHandler}>
                                  {child.name}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>   
              </div>
          </div>
          <div className='headerMobileData'>

          </div>
        </div>
    </header>
  )
}

export default Header

